import React, { ReactNode, useState } from "react";
import { MenuItemData, isCasinoMenuItemActive } from "./MenuUtils";
import { NavLink } from "react-router-dom";
import { BrandA } from "../buttons/buttons";
import { Collapse } from "react-bootstrap";
import { MenuItemType } from "../../http/protocol";

interface SubmenuProps {
  menuItem: MenuItemData;
  close?: () => void;
}

export default function Submenu(props: SubmenuProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleIsExpanded = () => {
    setIsExpanded((p) => !p);
  };

  const renderSubmenu = () => {
    if (props.menuItem && props.menuItem.subMenu && props.menuItem.subMenu.tabs) {
      const tabs = props.menuItem.subMenu.tabs.map((t, i) => {
        if (t.url?.startsWith("/")) {
          return (
            <NavLink
              key={i}
              onClick={() => {
                if (props.close) {
                  props.close();
                }
              }}
              className={"nav-link submenu-tab-link " + t.className}
              isActive={(match, location) => {
                if(location.search){
                  return (location.pathname + location.search) == t.url
                } else {
                  return match?.isExact ? true : false
                }
              }}
              to={t.url ?? ""}
            >
              {t.icon && <i className={"" + t.icon}></i>}
              {t.name}
            </NavLink>
          );
        } else {
          return (
            <BrandA
              key={i}
              className={"nav-link submenu-tab-link " + t.className}
              onClick={() => {
                if (props.close) {
                  props.close();
                }
              }}
              href={t.url ?? ""}
              target={t.target}
            >
              {t.icon && <i className={"" + t.icon}></i>}
              {t.name}
            </BrandA>
          );
        }
      });
      return (
        <div className={`submenu-container ${isExpanded ? "expanded-submenu-container" : ""}`}>
          <NavLink 
          className={"nav-link submenu-link expandable " + props.menuItem.className} 
          onClick={toggleIsExpanded}
          isActive={(match, location) => props.menuItem.url == location.pathname} 
          activeClassName={"active"} to={props.menuItem.expandSubmenuOnly ? "#" : props.menuItem.url ?? ""}>
            <div
              className="nav-link-logo"
              onClick={() => {
                if (props.close) {
                  props.close();
                }
              }}
            >
              {props.menuItem.icon?.className && <i className={"" + props.menuItem.icon?.className}></i>}
              {props.menuItem.text}
            </div>
            {props.menuItem && props.menuItem.subMenu && Boolean(props.menuItem.subMenu.tabs.length) && <ChevronButton setIsExpanded={toggleIsExpanded} isExpanded={isExpanded} />}
          </NavLink>
          <ExpandableSubMenu key={props.menuItem.url} isExpanded={isExpanded}>
            {tabs}
          </ExpandableSubMenu>
        </div>
      );
    }
  };

  return <div className="side-submenu-container">{renderSubmenu()}</div>;
}

interface ExpandableSubMenu {
  children: ReactNode | ReactNode[];
  isExpanded: boolean;
}

const ExpandableSubMenu = (props: ExpandableSubMenu) => {
  return (
    <Collapse in={props.isExpanded}>
      <div className={`expandeble-sub-menu ${props.isExpanded ? "expanded-sub-menu" : ""}`}>{props.children}</div>
    </Collapse>
  );
};

const ChevronButton = ({ isExpanded }: { isExpanded: boolean; setIsExpanded: any }) => {
  return (
    <div className="submenu-chevron">
      {isExpanded ? (
        <i
          className={"material-icons"}
        >
          expand_more
        </i>
      ) : (
        <i
          className={"material-icons"}
        >
          chevron_right
        </i>
      )}
    </div>
  );
};
